// extracted by mini-css-extract-plugin
export default {"lista":"ListaProjetos_lista__jQQpO"};